export default {
    en: {
        'length': 'The password length should be between 8 and 128',
        'charType': 'The password format is incorrect. It contains at least upper and lower case letters, numbers and special characters, and at least eight digits',
        'tooSimple': 'The password is too simple'
    },
    zh: {
        'length': '密码长度应该在8到128之间',
        'charType': '密码应该由至少8位大写字母，小写字母，特殊字符和数字组成，',
        'tooSimple': '密码太过简单'
    }
};
